import React from 'react';
import ReactDOM from 'react-dom';
export default function Portal({ target = document.body, children }) {
	return ReactDOM.createPortal(children, target);
}
